// components
import { Button } from '@mui/material';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import { MatchDrawerInfoContent } from './MatchDrawerInfoContent';
import { MatchDrawerTables } from './MatchDrawerTables';

// hooks
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { StyledLargeDrawerPaper } from './MatchDrawer.styles';

import type { MatchDrawerProps } from './MatchDrawer.types';

const MatchDrawer = ({
  isOpen,
  onClose,
  selectedRow,
  handleInfoClick,
  handleRejectRequest,
  handlePreferredEmployees
}: MatchDrawerProps) => {
  'use memo';

  const { t } = useTranslation('common', {
    keyPrefix: 'flexMatch'
  });
  const { t: tCommon } = useTranslation('common');
  const methods = useForm();
  const { handleSubmit } = methods;

  const handleClose = () => {
    onClose?.();
  };

  const onSubmit = () => {
    // console.table('🚀 ~ onSubmit ~ data:', data);
  };

  return (
    <StyledLargeDrawerPaper
      open={isOpen}
      title={t('matchDrawer.title', {
        requestId: selectedRow?.requestId || '-'
      })}
      onClose={handleClose}
    >
      <FormProvider {...methods}>
        <MultiStepForm onSubmit={handleSubmit(onSubmit)} methods={methods}>
          {selectedRow && (
            <MatchDrawerInfoContent
              selectedRow={selectedRow}
              handleInfoClick={handleInfoClick}
              handleMatchDrawerClose={handleClose}
            />
          )}

          <MatchDrawerTables
            selectedRow={selectedRow}
            handlePreferredEmployees={handlePreferredEmployees}
            onClose={onClose}
            isOpen={isOpen}
          />
          <MultiStepForm.Actions>
            <Button
              type="button"
              variant="outlined"
              color="primary"
              onClick={() => {
                handleRejectRequest?.(selectedRow);
                handleClose();
              }}
            >
              {t('reject')}
            </Button>
            <Button
              loading={false}
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => {
                handleClose();
              }}
            >
              {tCommon('close')}
            </Button>
          </MultiStepForm.Actions>
        </MultiStepForm>
      </FormProvider>
    </StyledLargeDrawerPaper>
  );
};

export default MatchDrawer;
